<template lang="pug">
v-dialog(v-model="dialog" width="700" persistent)
    template(v-slot:activator="{ on, attrs }")
        v-btn.ml-2(small color="primary" dark v-bind="attrs" v-on="on")
            v-icon(small left) mdi-plus
            | Notification Tab Manager
    v-card
        v-card-title Manage Notification to Show
        v-card-text
            v-select(v-model="form.values" :items="templates" item-text="name" item-value="id" chips deletable-chips label="Select Notification Templates" multiple)

        v-divider
        v-card-actions
            v-spacer
            v-btn(v-if="!loading" small color="red" text @click="dialog = false") Cancel
            v-btn(small color="primary" text @click="update" :loading="loading") Submit
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
    props: {
        templates: {
            type: Array,
            default() {
                return [];
            }
        },
        values: {
            type: Array,
            default() {
                return [];
            }
        }
    },
    data() {
        return {
            dialog: false,
            loading: false,
            form: {
                values: this.values
            }
        };
    },
    // watch: {
    //     dialog(value) {
    //         if(value) {
    //             this.form = {
    //                 values: []
    //             };
    //         }
    //     }
    // },
    methods: {
        async update() {
            this.$emit('change', this.form.values);
            this.dialog = false;
        }
    }
}
</script>
    
    
    